import React, { useState } from "react";
import "../assets/styles.css";
import FacilitiesBanner from '../assets/pad-pro-facilities-banner.png';
import FacilitiesImageOne from '../assets/pad-pro-image-facilities-1.jpg';
import FacilitiesImageTwo from '../assets/pad-pro-image-facilities-2.jpg';
import FacilitiesImageThree from '../assets/pad-pro-image-facilities-3.jpg';
import FacilitiesImageFour from '../assets/pad-pro-image-facilities-4.jpg';
import FacilitiesImageFive from '../assets/pad-pro-image-facilities-5.jpg';
import FacilitiesImageSix from '../assets/pad-pro-image-facilities-6.jpg';
import FacilitiesImageSeven from '../assets/pad-pro-image-facilities-7.jpg';
import FacilitiesImageEight from '../assets/pad-pro-image-facilities-8.jpg';
import FacilitiesImageNine from '../assets/pad-pro-image-facilities-9.jpg';
import FacilitiesImageTen from '../assets/pad-pro-image-facilities-10.jpg';
import FacilitiesImageEleven from '../assets/pad-pro-image-facilities-11.jpg';
import FacilitiesImageTwelve from '../assets/pad-pro-image-facilities-12.jpg';
import FacilitiesImageThirteen from '../assets/pad-pro-image-facilities-13.jpg';
import FacilitiesImageFourteen from '../assets/pad-pro-image-facilities-14.jpg';
import FacilitiesImageOneFive from '../assets/pad-pro-image-facilities-15.jpg';

export default function FacilitiesSectionA() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const facilityImages = [
    { src: FacilitiesImageOne, alt: "PADPRO's Main Facility Exterior" },
    { src: FacilitiesImageTwo, alt: "PADPRO's Activity Room" },
    { src: FacilitiesImageThree, alt: "PADPRO's Computer Workstations" },
    { src: FacilitiesImageFour, alt: "PADPRO's Arts and Crafts Studio" },
    { src: FacilitiesImageFive, alt: "PADPRO's Conference Room" },
    { src: FacilitiesImageSix, alt: "PADPRO's Library Area" },
    { src: FacilitiesImageSeven, alt: "PADPRO's Recreation Hall" },
    { src: FacilitiesImageEight, alt: "PADPRO's Personal Grooming Room" },
    { src: FacilitiesImageNine, alt: "PADPRO's Kitchen and Pantry" },
    { src: FacilitiesImageTen, alt: "PADPRO's Bathroom Facilities" },
    { src: FacilitiesImageEleven, alt: "PADPRO's Sensory Room" },
    { src: FacilitiesImageTwelve, alt: "PADPRO's Exercise Area" },
    { src: FacilitiesImageThirteen, alt: "PADPRO's Group Assembly Room" },
    { src: FacilitiesImageFourteen, alt: "PADPRO's Television/Video Room" },
    { src: FacilitiesImageOneFive, alt: "PADPRO's Wheelchair Accessible Entrance" },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % facilityImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + facilityImages.length) % facilityImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const openLightbox = (index) => {
    setSelectedImage(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextLightboxImage = () => {
    setSelectedImage((prev) => (prev + 1) % facilityImages.length);
  };

  const prevLightboxImage = () => {
    setSelectedImage((prev) => (prev - 1 + facilityImages.length) % facilityImages.length);
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-64 sm:h-80 md:h-96 overflow-hidden" data-aos="fade-up" data-aos-duration="1000">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${FacilitiesBanner})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
        </div>
        
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-green-400 mb-2 sm:mb-4 newsreader">
                Our Facilities
              </h1>
              
              <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-50 font-medium mb-2 sm:mb-4 newsreader px-2">
                Purpose-built spaces that inspire independence and well-being.              
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 bg-white" data-aos="fade-right" data-aos-duration="1000">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl text-gray-900 mb-4 sm:mb-6 md:mb-8 newsreader">
              Designed for Care & Comfort
            </h2>
            
            <p className="text-sm sm:text-base md:text-base lg:text-md text-black leading-relaxed px-2">
              Our facilities are thoughtfully designed to support adults with intellectual disabilities through safe, accessible, and welcoming environments. Every space encourages independence, skill-building, and community interaction.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-8 sm:py-12 md:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center mb-8 sm:mb-10 md:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl text-gray-900 mb-4 sm:mb-6 md:mb-8 newsreader">
              Gallery
            </h2>
            
            <div className="space-y-3 sm:space-y-4 text-black leading-relaxed px-2">
              <p className="text-sm sm:text-base md:text-base lg:text-md">
                 It has centralized air-conditioning/heater, sprinkler system, 5 bathrooms and a personal grooming room; computer workstations with a mini-library; arts and crafts studio; a conference room; and easy access to and from the front and back with wheelchair ramps; and adequate parking.
              </p>
              <p className="text-sm sm:text-base md:text-base lg:text-md">
                There is also a social-recreational hall with designated areas for exercises and aerobics as well as a television/video room; a room for sensory-impaired individuals, a pantry, and group/assembly work rooms.
              </p>
            </div>
          </div>

          {/* Main Gallery Container */}
          <div className="relative max-w-5xl mx-auto">
            {/* Main Image Display */}
            <div className="relative bg-white rounded-lg shadow-lg overflow-hidden mb-4 sm:mb-6">
              <div className="relative h-64 sm:h-80 md:h-96 lg:h-[450px] xl:h-[550px]">
                <img
                  src={facilityImages[currentSlide].src}
                  alt={facilityImages[currentSlide].alt}
                  className="h-full w-full object-cover rounded-lg cursor-pointer"
                  onClick={() => openLightbox(currentSlide)}
                />
              </div>

              {/* Slide indicators - hide on small screens */}
              <div className="absolute bottom-3 sm:bottom-4 md:bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-1 sm:space-x-2">
                {facilityImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full transition-all duration-200 ${
                      currentSlide === index ? 'bg-green-500' : 'bg-white/60 hover:bg-white/80'
                    }`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* Navigation arrows for main image - visible on small screens */}
            <div className="block sm:hidden">
              <button
                onClick={prevSlide}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full z-10"
                aria-label="Previous image"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              
              <button
                onClick={nextSlide}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full z-10"
                aria-label="Next image"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

            {/* Thumbnail Navigation - hidden on small screens, visible from sm up */}
            <div className="relative hidden sm:block">
              {/* Thumbnail Grid */}
              <div className="flex overflow-x-auto space-x-2 sm:space-x-3 pb-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                {facilityImages.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`flex-shrink-0 w-16 h-12 sm:w-20 sm:h-16 md:w-24 md:h-20 overflow-hidden rounded-md transition-all duration-200 ${
                      currentSlide === index 
                        ? 'ring-2 sm:ring-3 ring-green-500 shadow-lg' 
                        : 'ring-1 ring-gray-200 hover:ring-2 hover:ring-green-300 opacity-80 hover:opacity-100'
                    }`}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
              
              {/* Thumbnail navigation arrows */}
              <div className="absolute top-1/2 transform -translate-y-1/2 -left-3 sm:-left-4">
                <button
                  onClick={() => {
                    const container = document.querySelector('.flex.overflow-x-auto');
                    container.scrollBy({ left: -200, behavior: 'smooth' });
                  }}
                  className="w-6 h-6 sm:w-8 sm:h-8 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-200"
                  aria-label="Scroll thumbnails left"
                >
                  <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
              </div>
              
              <div className="absolute top-1/2 transform -translate-y-1/2 -right-3 sm:-right-4">
                <button
                  onClick={() => {
                    const container = document.querySelector('.flex.overflow-x-auto');
                    container.scrollBy({ left: 200, behavior: 'smooth' });
                  }}
                  className="w-6 h-6 sm:w-8 sm:h-8 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-200"
                  aria-label="Scroll thumbnails right"
                >
                  <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Mobile thumbnail strip - visible only on small screens */}
            <div className="block sm:hidden mt-4">
              <div className="flex overflow-x-auto space-x-2 pb-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                {facilityImages.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`flex-shrink-0 w-12 h-10 overflow-hidden rounded transition-all duration-200 ${
                      currentSlide === index 
                        ? 'ring-2 ring-green-500 shadow-lg' 
                        : 'ring-1 ring-gray-200 opacity-80'
                    }`}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-2 sm:p-4">
          <div className="relative max-w-full max-h-full sm:max-w-4xl">
            <button
              onClick={closeLightbox}
              className="absolute -top-8 sm:-top-12 right-0 text-white hover:text-gray-300 text-xl sm:text-2xl"
              aria-label="Close lightbox"
            >
              <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <img
              src={facilityImages[selectedImage].src}
              alt={facilityImages[selectedImage].alt}
              className="max-w-full max-h-[80vh] sm:max-h-full object-contain rounded-lg"
            />
            
            <button
              onClick={prevLightboxImage}
              className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 sm:p-3 rounded-full"
              aria-label="Previous image"
            >
              <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            <button
              onClick={nextLightboxImage}
              className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 sm:p-3 rounded-full"
              aria-label="Next image"
            >
              <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
            
            <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 text-white text-xs sm:text-sm bg-black/50 px-2 sm:px-3 py-1 rounded">
              {selectedImage + 1} / {facilityImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}